export default __webpack_public_path__ + "static/img_cash_in_transit.png";